import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Smartphone, X } from "lucide-react";

export default function InstallBanner() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // האזנה לאירוע שהדפדפן מוכן להתקנה
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault(); // מניעת ההקפצה האוטומטית של הדפדפן
            setDeferredPrompt(e); // שמירת האירוע לשימוש מאוחר יותר
            setIsVisible(true);
        });

        // האזנה למקרה שהאפליקציה כבר הותקנה
        window.addEventListener('appinstalled', () => {
            setIsVisible(false);
            setDeferredPrompt(null);
        });
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        
        deferredPrompt.prompt(); // הצגת חלון ההתקנה
        const { outcome } = await deferredPrompt.userChoice;
        
        if (outcome === 'accepted') {
            setIsVisible(false);
        }
        setDeferredPrompt(null);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-4 left-4 right-4 z-[100] bg-white border border-red-100 shadow-2xl rounded-2xl p-4 animate-in fade-in slide-in-from-bottom-10">
            <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="bg-red-100 p-2 rounded-xl text-red-600">
                        <Smartphone className="w-6 h-6" />
                    </div>
                    <div>
                        <p className="font-bold text-sm text-gray-900">התקן את האפליקציה</p>
                        <p className="text-xs text-gray-500">לגישה מהירה מהמסך הבית</p>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <Button onClick={handleInstallClick} size="sm" className="bg-red-600 hover:bg-red-700 text-white font-bold">
                        התקן
                    </Button>
                    <button onClick={() => setIsVisible(false)} className="p-1 text-gray-400">
                        <X className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </div>
    );
}